<template>
    <div class="container layout">
        <top title="Hadi Mülakat Deneyimini Paylaş!"
            desc="Mülakat deneyimini paylaşarak diğer mülakatları anında incelemeye başla!" :PrivacyAccordion="true"></top>
        <div class="columns is-marginless">
            <div class="column is-7">
                <div class="column is-full">
                    <div>
                        <privacy-accordion class="is-hidden-tablet"></privacy-accordion>
                    </div>
                    <div class="box form interview-form">
                        <section>
                            <b-field label="Hangi şirket için paylaşıyorsun?*"
                                :type="{ 'is-danger': !company.selected && !valid }"
                                :message="{ 'Bir şirket seçmelisin': !company.selected && !valid }">
                                <b-autocomplete ref="companyAutocomplete" v-model="company.name" :data="company.data"
                                    placeholder="Şirket Ara" field="companyName" :loading="company.isFetching"
                                    @input="getAutoCompleteService('company')" @select="option => company.selected = option"
                                    :open-on-focus="true" icon-pack="mdi" icon="magnify">
                                </b-autocomplete>
                            </b-field>

                            <b-field label="Hangi pozisyon için paylaşıyorsun?*"
                                :type="{ 'is-danger': !position.selected && !valid }"
                                :message="{ 'Bir pozisyon seçmelisin': !position.selected && !valid }">
                                <b-autocomplete ref="positionAutocomplete" v-model="position.name" :data="position.data"
                                    placeholder="Pozisyon Ara" field="name" :loading="position.isFetching"
                                    @input="getAutoCompleteService('position')"
                                    @select="option => position.selected = option" :open-on-focus="true" icon-pack="mdi"
                                    icon="magnify">
                                </b-autocomplete>
                            </b-field>

                            <b-field label="Mülakatta hangi sorular soruldu?">
                                <div class="is-block">
                                    <p class="field-label-text">
                                        Sık sorulan 10 mülakat sorusunu listeledik. Birden fazla soru seçebilirsin.
                                    </p>
                                    <div class="checkbox-wrap">
                                        <div class="is-block checkbox-content"
                                            :class="{ 'checkbox-content-selected': predefinedQuestionsSelected.indexOf(item.interviewPredefinedQuestionId) !== -1 }"
                                            v-for="(item, index) in predefinedQuestionsControl" :key="index">
                                            <b-checkbox v-model="predefinedQuestionsSelected"
                                                :native-value="item.interviewPredefinedQuestionId" type="is-checkboxcolor"
                                                @click.native="index === 4 ? showMore = true : null">{{ item.question }}</b-checkbox>
                                        </div>
                                    </div>
                                    <div class="is-block">
                                        <p class="help is-danger"
                                            v-if="predefinedQuestionsSelected.length === 0 && !customQuestions && !valid">
                                            Bir mülakat sorusu seçmelisin</p>
                                    </div>

                                    <div class="has-text-centered has-text-show-more">
                                        <a href="javascript:;" class="has-text-info has-text-weight-semibold is-size-8"
                                            @click="showMore = true" v-if="!showMore && predefinedQuestions.length > 0">Daha
                                            fazla gör</a>
                                    </div>
                                </div>

                            </b-field>

                            <b-field label="Başka mülakat sorusu soruldu mu?">
                                <b-field>
                                    <b-radio-button v-model="customQuestions" type="is-info" :native-value="true">
                                        <span>Evet</span>
                                    </b-radio-button>

                                    <b-radio-button v-model="customQuestions" type="is-info" :native-value="false">
                                        <span>Hayır</span>
                                    </b-radio-button>
                                </b-field>
                            </b-field>

                            <b-field class="is-question-field is-block" v-if="customQuestions">
                                <b-input type="textarea" lang="tr" class="is-fullwidth" placeholder="Buraya yazın"
                                    v-model="item.value" v-for="(item, index) in questions" :key="index"></b-input>
                                <div class="is-block">
                                    <p class="help is-danger" v-if="questionsArr.length === 0 && customQuestions && !valid">
                                        Bir mülakat sorusu girmelisin</p>
                                </div>
                                <div class="is-flex">
                                    <p class="has-text-right" style="margin-left:auto">
                                        <a href="javascript:;" class="is-size-8 has-text-weight-semibold"
                                            @click="addNewQuestions"><b-icon icon="plus" size="is-small"></b-icon> Yeni soru
                                            ekle</a>
                                    </p>
                                </div>
                            </b-field>

                            <div class="recaptcha">
                                <recaptcha type="interview" :valid="reCaptchaValid"
                                    @verify="reCaptchaValue = $event, checkReCaptcha()"></recaptcha>
                            </div>

                            <div class="buttons is-centered">
                                <button class="button is-primary is-uppercase has-text-weight-semibold interview-save"
                                    :class="isLoading ? 'is-loading' : ''" @click="addInterview"
                                    :disabled="isLoading">Bilgileri Onayla</button>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <div class="column is-hidden-mobile">
                <privacy-accordion></privacy-accordion>
            </div>
        </div>
    </div>
</template>

<script>
import apiConfigs from '@/services/config'

import autocomplete from '@/mixins/autocomplete'

import top from '@/components/Top'
import PrivacyAccordion from '@/components/PrivacyAccordion'
import recaptcha from "@/components/Recaptcha"

import autosize from 'autosize'

export default {
    name: "Interview",
    components: { PrivacyAccordion, top, recaptcha },
    mixins: [autocomplete],
    data() {
        return {
            customQuestions: true,
            valid: true,
            showMore: false,
            predefinedQuestions: [],
            predefinedQuestionsSelected: [],
            questions: [{
                value: ''
            }],
            isLoading: false,
            reCaptchaValue: null,
            reCaptchaValid: true
        }
    },
    methods: {
        formValid(params) {
            let formKeys = ['companyId', 'positionId'],
                formElementValid = {},
                valid

            // add custom questions control
            if (this.customQuestions) formKeys.push('interviewQuestions')
            else formKeys.push('interviewPredefinedQuestions')

            // form valid  control
            formKeys.map(item => formElementValid[item] = Object.keys(params).indexOf(item))
            valid = !Object.values(formElementValid).includes(-1)

            return valid
        },
        getPredefined() {
            apiConfigs.serviceWrapper(apiConfigs.serviceConfigs.interview, apiConfigs.serviceConfigs.interview.predefined, null)
                .then((response) => {
                    let data = response.data
                    if (data.statusCode == 200) {
                        this.predefinedQuestions = response.data.result
                    }
                })
        },

        addNewQuestions() {
            this.questions.push({ value: null })
            this.setAutoSize()
        },
        setAutoSize() {
            this.$nextTick(() => {
                autosize(document.querySelectorAll('textarea'))
            });
        },
        addInterview() {
            let params = {};

            if (this.company.selected) {
                params.companyId = this.company.selected.companyId;
                params.companyName = this.company.selected.companyName;
            }

            if (this.position.selected) {
                params.positionId = this.position.selected.id;
            }

            if (this.predefinedQuestionsSelected.length > 0) {
                params.interviewPredefinedQuestions = this.predefinedQuestionsSelected;
            }

            if (this.questionsArr.length > 0) {
                params.interviewQuestions = this.questionsArr
            }

            this.valid = this.formValid(params);

            this.checkReCaptcha();

            if (!this.valid) {
                // scroll top is danger
                this.$nextTick(() => {
                    document.querySelectorAll('.is-danger')[0].scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
                });
                return false
            }

            this.isLoading = true;

            apiConfigs.serviceWrapper(apiConfigs.serviceConfigs.interview, apiConfigs.serviceConfigs.interview.add, params, { CKEY: this.reCaptchaValue.key })
                .then((response) => {
                    let data = response.data;
                    if (data.statusCode == 200) {

                        // set company, position information
                        sessionStorage.setItem('userCompany', JSON.stringify(this.company.selected))
                        sessionStorage.setItem('userPosition', JSON.stringify(this.position.selected))

                        // salary complete
                        this.$router.push({ name: 'InterviewDetail', params: { id: data.result.interviewId } })
                    }
                    this.isLoading = false;
                })

                .catch(() => {
                    this.isLoading = false;
                })
        },
        checkReCaptcha() {
            if (!this.reCaptchaValue || (!this.reCaptchaValue.key && this.reCaptchaValue.enabled)) {
                this.reCaptchaValid = false;
                this.valid = false;
            }
            else
                this.reCaptchaValid = true
        }
    },
    computed: {
        predefinedQuestionsControl() {
            return this.showMore ? this.predefinedQuestions : this.predefinedQuestions.slice(0, 5)
        },
        questionsArr() {
            return this.questions.filter((item) => { if (item.value && item.value.trim() !== '') return item.value }).map((item) => { return item.value })
        }
    },
    created() {
        this.getPredefined()
        this.setAutoSize()
    }
}
</script>

<style scoped></style>